import { useDispatch } from "react-redux";
import { getCurrentUserProfile } from "../../controllers/SpotifyApiController"
import { setUserProfile } from "../../actions/userProfileActions";
import { simplifyUserProfile } from "../../utils/spotifyUtils";
import { useEffect } from "react";
import { manageTooManyRequestsResponse } from "../../utils/connectionUtils";

export const useUserProfile = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        getCurrentUserProfile()
        .then((result) => {
            dispatch(setUserProfile(simplifyUserProfile(result)));
        })
        .catch((error) => {
            manageTooManyRequestsResponse(error, dispatch);
            console.error("Error while getting current user's profile", error)
        });
    }, [dispatch])
}